import { CommonModule, NgOptimizedImage } from '@angular/common';
import { Injector, NgModule } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DcAlertModule } from '@datachain/ui-sdk/components/alert';
import { DcBadgeModule } from '@datachain/ui-sdk/components/app-badge';
import { DcButtonModule } from '@datachain/ui-sdk/components/app-button';
import { DcCardOutlineModule } from '@datachain/ui-sdk/components/app-card-outline';
import { DcColumnTypeModule } from '@datachain/ui-sdk/components/app-column-type';
import { DcOverlayBadgeModule } from '@datachain/ui-sdk/components/app-overlay-badge';
import { DcPageModule } from '@datachain/ui-sdk/components/app-page';
import { DcPanelModule } from '@datachain/ui-sdk/components/app-panel';
import { DcPopoverModule } from '@datachain/ui-sdk/components/app-popover';
import { DcAvatarModule } from '@datachain/ui-sdk/components/avatar';
import { DcBreadcrumbModule } from '@datachain/ui-sdk/components/breadcrumb';
import {
	DcHighlightDirectiveModule,
	DcNavigateDirectiveModule,
} from '@datachain/ui-sdk/directives';
import {
	DcArrayPipeModule,
	DcTruncatePipeModule,
} from '@datachain/ui-sdk/pipes';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import {
	DxDataGridModule,
	DxSelectBoxModule,
	DxTextBoxModule,
	DxValidatorModule,
} from 'devextreme-angular';

import { MaterialModule } from '../ui/material.module';
import { UiModule } from '../ui/ui.module';
import { ChangeVersionModalComponent } from './components/change-version-modal/change-version-modal.component';
import { CreateEntityFromDepotModalComponent } from './components/create-entity-from-depot-modal/create-entity-from-depot-modal.component';
import { DepotActionPopupComponent } from './components/depot-action-popup/depot-action-popup.component';
import { DepotCreationModalComponent } from './components/depot-creation-modal/depot-creation-modal.component';
import { DepotListComponent } from './components/depot-list/depot-list.component';
import { DcCoreDepotSchemaViewerModule } from './components/depot-schema-viewer/depot-schema-viewer.component';
import { AppHeaderMappingModalComponent } from './components/header-mapping-modal/header-mapping-modal.component';
import { DepotAdapter } from './depot.adapter';
import { NgDepot } from './ng-depot';
import {
	DepotConfigEffects,
	DepotConfigSelector,
	DepotEffects,
	DepotFeatureKey,
	depotReducers,
	DepotSelector,
} from './store';

@NgModule({
	declarations: [
		DepotListComponent,
		DepotActionPopupComponent,
		CreateEntityFromDepotModalComponent,
		AppHeaderMappingModalComponent,
		DepotCreationModalComponent,
		ChangeVersionModalComponent,
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		UiModule,
		MaterialModule,
		StoreModule.forFeature(DepotFeatureKey, depotReducers),
		EffectsModule.forFeature([DepotEffects, DepotConfigEffects]),
		DxDataGridModule,
		DxSelectBoxModule,
		DxTextBoxModule,
		DxValidatorModule,
		NgOptimizedImage,
		DcPageModule,
		DcPanelModule,
		DcArrayPipeModule,
		DcBadgeModule,
		DcAvatarModule,
		DcNavigateDirectiveModule,
		DcBreadcrumbModule,
		DcColumnTypeModule,
		CommonModule,
		MaterialModule,
		DcCoreDepotSchemaViewerModule,
		FormsModule,
		DcButtonModule,
		DcColumnTypeModule,
		DcHighlightDirectiveModule,
		DcTruncatePipeModule,
		DcOverlayBadgeModule,
		DcPopoverModule,
		DcCardOutlineModule,
		DcAlertModule,
	],
	providers: [DepotAdapter, DepotSelector, DepotConfigSelector, NgDepot],
})
export class DepotModule {
	public constructor(private readonly injector: Injector) {
		const depotListCmpElement = createCustomElement(DepotListComponent, {
			injector,
		});
		customElements.define('app-depot-list', depotListCmpElement);
	}
}
